export default {
  create: function create() {
    return Promise.resolve({
      data: null
    });
  },
  delete: function _delete() {
    return Promise.resolve({
      data: null
    });
  },
  deleteMany: function deleteMany() {
    return Promise.resolve({
      data: []
    });
  },
  getList: function getList() {
    return Promise.resolve({
      data: [],
      total: 0
    });
  },
  getMany: function getMany() {
    return Promise.resolve({
      data: []
    });
  },
  getManyReference: function getManyReference() {
    return Promise.resolve({
      data: [],
      total: 0
    });
  },
  getOne: function getOne() {
    return Promise.resolve({
      data: null
    });
  },
  update: function update() {
    return Promise.resolve({
      data: null
    });
  },
  updateMany: function updateMany() {
    return Promise.resolve({
      data: []
    });
  } // avoids adding a context in tests

};